import { Box, Stack, Typography } from "@mui/material";
import { useState } from "react";
import styles from "./styles.module.css";
import DataGridComp from "../../../components/DataGrid/DataGrid";
import AttendanceRequestQuery from "../../../utils/reactQuery/manager/attendance/AttendanceRequest";
import viewIcon from "../../../styles/icons/viewicon.svg";
import ManagerNote from "../../../components/managerNote/ManagerNote";
import TableHeader from "../../../components/TableHeader/TableHeader";
import Loader from "../../../components/Loader";
import deleteIcon from "../../../styles/svg/deleteIcon.svg";
import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import deleteAttendanceRequest from "../../../services/manager/attendance/apiDeleteAttendance";
import ConfirmModal from "../../../components/ConfirmationModal/ConfirmModal";

export default function EmployeeAttendanceRequest({ employeeId }) {
  const { attendanceRequestList, isLoading, refetch } =
    AttendanceRequestQuery(employeeId);
  const [notePopover, setNotePopover] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [confirmDelete, setConfirmDelete] = useState(false);

  const handleView = (id) => {
    setNotePopover(true);
    setSelectedId(id);
  };

  const { mutate } = useMutation({
    mutationFn: deleteAttendanceRequest,
    onSuccess: (data) => {
      refetch();
      toast.success(data.data.message);
    },
    onError: (error) => {
      toast.error(error.response.data.error);
    },
    onSettled: () => {
      setConfirmDelete(false);
    },
  });

  const handleDelete = (id) => {
    setConfirmDelete(true);
    setSelectedId(id);
  };

  const handleConfirmDelete = () => {
    mutate(selectedId);
  };

  const columns = [
    {
      field: "col1",
      headerName: "Employee Name",
      minWidth: 127,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
    },
    {
      field: "col2",
      headerName: "Entry Type",
      minWidth: 127,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
    },
    {
      field: "col3",
      headerName: "In",
      minWidth: 126,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
    },
    {
      field: "col4",
      headerName: "Out",
      minWidth: 120,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
    },
    {
      field: "col5",
      headerName: "Date",
      minWidth: 120,
      flex: 1,
      sortable: true,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
      sortComparator: (date1, date2) => new Date(date1) - new Date(date2),
    },
    {
      field: "col6",
      headerName: "Date Created",
      minWidth: 120,
      flex: 1,
      sortable: true,
      resizable: false,
      renderCell: (value) => <span>{value.value}</span>,
      sortComparator: (date1, date2) => new Date(date1) - new Date(date2),
    },
    {
      field: "col7",
      headerName: "Status",
      minWidth: 120,
      flex: 1,
      sortable: true,
      resizable: false,
      renderCell: (value) => (
        <Stack className={styles.statusCont}>
          <Typography
            className={
              value.value === "Approved"
                ? styles.statusApproved
                : styles.statusPending
            }
          >
            {value.value}
          </Typography>
        </Stack>
      ),
    },
    {
      field: "col8",
      headerName: "Actions",
      minWidth: 120,
      flex: 1,
      sortable: false,
      resizable: false,
      renderCell: (value) => (
        <Stack className={styles.iconsCont}>
          <img
            className={styles.icon}
            src={viewIcon}
            onClick={() => handleView(value.value.id)}
            alt="view"
          />
          {!value.value.isApproved && (
            <img
              className={styles.icon}
              src={deleteIcon}
              onClick={() => handleDelete(value.value.id)}
              alt="reject"
            />
          )}
        </Stack>
      ),
    },
  ];
  return (
    <Box className={styles.mainContainer}>
      <TableHeader heading="Attendance Approvals" />
      <Box className={styles.datagridCont}>
        {isLoading && (
          <Stack className={styles.loaderCont}>
            <Loader />
          </Stack>
        )}
        <DataGridComp
          columns={columns}
          initialRows={attendanceRequestList || []}
        />
      </Box>
      {notePopover && (
        <ManagerNote
          openPop={notePopover}
          handleClose={() => setNotePopover(false)}
          id={selectedId}
        />
      )}
      {confirmDelete && (
        <ConfirmModal
          openProp={confirmDelete}
          handleClose={() => setConfirmDelete(false)}
          handleConfirm={handleConfirmDelete}
          tabHeader="Delete Confirmation"
          heading="Are You Sure?"
          content="Deleting this item will remove it permanently. Do you want to proceed?"
          btnText="delete"
        />
      )}
    </Box>
  );
}
